<!-- <i
  >Read and write IRWIN data using this troubleshooting tool outside the regular
  WFDSS incident workflow</i
>
Begin by fecthing WFDSS and Irwin data using the Incident IRWIN ID: -->
<div style="display: flex; align-items: center; justify-content: center">
    <mat-form-field style="min-width: 350px">
        <mat-label for="irwinId">Enter IRWIN ID</mat-label>
        <input id="irwinId" matInput [(ngModel)]="irwinId" name="irwinId" />
    </mat-form-field>
    <button
        class="primary-button"
        style="margin-left: 15px; height: fit-content"
        (click)="onIrwinIdChangeRequested()"
    >
        Fetch Data
    </button>
</div>
<div
    *ngIf="!irwinData"
    style="display: flex; align-items: center; justify-content: center"
>
    <div style="text-align: center; width: 100%">
        <i>Search for Irwin Id to get started</i>
    </div>
</div>
<div
    *ngIf="irwinData"
    style="display: flex; justify-content: center; flex-wrap: wrap"
>
    <div
        style="
      min-width: 480px;
      max-width: 50%;
      border-right: 5px solid black;
      padding-right: 5px;
    "
    >
        <h4>WFDSS Case Data</h4>
        <div>
            <div style="display: flex; flex-wrap: wrap">
                <div
                    *ngFor="let attribute of wfdssCaseDataAttrs"
                    style="
            border-bottom: 2px #0071bc dotted;
            margin: 3px;
            padding: 1px;
            background-color: #fbfcfb;
            border-radius: 10px;
            flex: 1 300px;
          "
                >
                    <div style="display: flex; align-items: center">
                        <mat-form-field style="min-width: 350px">
                            <mat-label [for]="attribute.key">{{ attribute.name }}</mat-label>
                            <input
                                [id]="attribute.key"
                                matInput
                                #attributeInput
                                [name]="attribute.key"
                                [value]="attribute.value ? attribute.value : ''"
                                (input)="onInput($event, attribute.key)"
                                [type]="attribute.type"
                            />
                        </mat-form-field>
                        <button *ngIf="!['FireStrategyDirExtPercent', 'FireStrategyIndirConfPercent', 'FireStrategyConfinePercent', 'FireStrategyFullSuppPercent', 'FireStrategyMonitorPercent', 'FireStrategyPointZonePercent'].includes(attribute.key)"
                            class="primary-button"
                            style="margin-left: 15px; height: fit-content"
                            (click)="
                onPushIrwinAttribute(attribute.key, attributeInput.value)
              "
                        >
                            Push
                        </button>
                    </div>
                    <div *ngIf="attribute.validOptions" style="max-width: 450px">
                        <details>
                            <summary style="color: #0071bc">Valid Options</summary>
                            <p>{{ attribute.validOptions }}</p>
<!--                            <div *ngIf="attribute.key === 'StrategicDecisionPublishDate'">-->
<!--                                <mat-form-field>-->
<!--                                    <input-->
<!--                                        #dateInputConverter-->
<!--                                        matInput-->
<!--                                        type="datetime-local"-->
<!--                                        placeholder="start date"-->
<!--                                    />-->
<!--                                </mat-form-field>-->
<!--                                <p>-->
<!--                                    Numeric Value:-->
<!--                                    {{ dateInputConverter.value | dateStringToUnix }}-->
<!--                                </p>-->
<!--                            </div>-->
                        </details>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: end">
                <button
                    class="primary-button"
                    style="margin-left: 15px; height: fit-content; margin-bottom: 10px"
                    (click)="pushValues(false)"
                >
                    Push Non-empty >>
                </button>
                <button
                    class="primary-button"
                    style="margin-left: 15px; height: fit-content"
                    (click)="pushValues(true)"
                >
                    Push All >>
                </button>
            </div>
        </div>
    </div>
    <div style="min-width: 480px; max-width: 50%; margin-left: 15px">
        <div
            style="display: flex; align-items: center; justify-content: space-between"
        >
            <h4>IRWIN Data</h4>
            <div>
                Irwin ID: <b>{{ irwinData.IrwinID }}</b>
            </div>
        </div>
        <div>
            <div style="display: flex">
                <div style="margin-right: 30px">
                    <div>
                        Incident name: <b>{{ irwinData.IncidentName }}</b>
                    </div>
                    <div style="margin-top: 3px">
                        <a [href]="getIrwinObserverURL()"
                           target="_blank"
                        >IRWIN Observer &#8599;</a>
                    </div>
                </div>
                <div style="margin-left: auto">
                    <div style="display: flex">
                        <button
                            class="primary-button"
                            (click)="showIrwinModal('irwinJSONDisplayText')"
                        >
                            IRWIN JSON
                        </button>
                        <button
                            class="primary-button"
                            style="margin-left: 5px"
                            (click)="onFullIrwinJsonClicked()"
                        >
                            Full IRWIN JSON
                        </button>
                    </div>
                </div>
            </div>
            <wfdss-configurable-mat-table
                [dataSource]="irwinDataTabularized"
                [columnMetaInformationIn]="IrwinDataTableColumnMetaData"
                [sortingDataAccessor]="sortingDataAccessor"
                [showExport]="true"
                [exportPrefix]="'json_irwin_' + irwinData.IrwinID"
                exportSuffix=""
            ></wfdss-configurable-mat-table>
        </div>
    </div>

    <dialog #rawJSONDialog>
        <div style="display: flex; justify-content: end; margin-bottom: 5px">
            <button (click)="rawJSONDialog.close()" class="primary-button">
                Close
            </button>
        </div>
        <textarea
            style="width: 60vw; max-width: 960px; height: 90vh"
            [value]="dialogTextAreaValue"
            readonly
        ></textarea>
    </dialog>
</div>
